import { gql } from '@apollo/client';

export const UPDATE_APP_SUB_SECTION_PERMISSION = gql`
  mutation UpdateAppSubSectionPermission($input: UpdateAppSubSectionPermissionInput) {
    updateAppSubSectionPermission(input: $input) {
      id
    }
  }
`;
